import {validationMixin} from 'vuelidate';

export default {
  mixins: [
    validationMixin,
  ],
  data() {
    return {
      submitAttempted: false,
    };
  },
  computed: {
    validationErrors() {
      if (!this.$v.$invalid) return {};

      const errors = {};

      Object.keys(this.$v).forEach((field) => {
        if (field.charAt(0) !== '$') {
          Object.keys(this.$v[field]).forEach((validationRule) => {
            if (errors[field]) return;

            if (validationRule.charAt(0) !== '$' && this.$v[field][validationRule] === false) {
              const fieldName = this.$options.mapFieldNames[field];
              errors[field] = this.$options.overrideErrorMessage[validationRule]
                ? this.$options.overrideErrorMessage[validationRule](fieldName)
                : this.getErrorMessage(validationRule, fieldName);
            }
          });
        }
      });

      return errors;
    },
  },
  methods: {
    focusOnFieldWithError() {
      for (let key in Object.keys(this.$v)) {
        const input = Object.keys(this.$v)[key];
        if (input.includes("$")) return false;

        if (this.$v[input].$error && this.$refs[input]) {
          if (Array.isArray(this.$refs[input])) {
            this.$refs[input][0].focus();
          } else {
            this.$refs[input].focus();
          }

          break;
        }
      }
    },

    getErrorMessage(validationType, fieldLabel = 'Field') {
      switch (validationType) {
        case 'required':
        case 'hmoRequired':
        case 'requiredInVerifyMode':
        case 'requiredInHmoPaymentForm':
          return `${fieldLabel} is required.`;

        case 'alphaSpaces':
          return `${fieldLabel} must only contain letters and spaces.`;

        case 'dateStringIsValid':
        case 'dateStringIsValidInVerifyMode':
        case 'dateStringIsLessThan':
        case 'dateStringIsLessThanInVerifyMode':
          return `${fieldLabel} is an invalid date.`;

        case 'mobileNumberValid':
          return `${fieldLabel} is invalid.`;

        case 'requiredCheckBox':
          return `${fieldLabel} must be checked to proceed.`;

        case 'email':
          return `${fieldLabel} is an invalid email address`;

        default:
          return 'Field is invalid';
      }
    },
  },
  mapFieldNames: {},
  /**
   * Example:
   * [validationRule]: (fieldName, params) => `${fieldName} is invalid`,
   */
  overrideErrorMessage: {},
}